module.exports = "/_next/static/images/GenerativeAI-689e6519f1508a3c2e2a07cf83cfd03e.webp";